var _path, _circle, _path2, _rect, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlineScamServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 105,
    viewBox: "0 0 130 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.273 37.8662C103.273 37.8659 103.273 37.8657 103.273 37.8654C103.273 19.3918 86.4251 4.41602 65.6423 4.41602C44.8595 4.41602 28.0117 19.3918 28.0117 37.8654C28.0117 37.8657 28.0117 37.8659 28.0117 37.8662V71.3156H103.273V37.8662Z",
    fill: "#DE2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.9563,
    cy: 35.8577,
    r: 5.5481,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5062 22.913C52.0449 15.5125 63.1505 9.96442 77.9455 15.5125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.6133,
    y: 74.6943,
    width: 88.7695,
    height: 25.8911,
    rx: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8469,
    cy: 50.6506,
    r: 12.9456,
    fill: "#AD0B0B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineScamServiceMain);
export default __webpack_public_path__ + "static/media/IcOnlineScamServiceMain.52e3c93d2514cfc6730037e453616e34.svg";
export { ForwardRef as ReactComponent };